var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../icon';
import Label from '../label';
import Theme from '../theme.config';
import { Styled } from './style';
var AppCard = /** @class */ (function (_super) {
    __extends(AppCard, _super);
    function AppCard(props) {
        return _super.call(this, props) || this;
    }
    AppCard.prototype.render = function () {
        var _this = this;
        return (React.createElement(Styled, { onClick: function () {
                return _this.props.onClick(_this.props.id, _this.props.name, _this.props.scrn, _this.props.url, _this.props.longDescription, _this.props.categories, _this.props.thumbnail, _this.props.configuration, _this.props.screenshots, _this.props.howToUrl, _this.props.feedbackUrl, _this.props.supportUrl, _this.props.appInstallURL);
            } },
            this.props.appInstallURL
                ? React.createElement("span", { className: "app-installed" },
                    React.createElement(Label, { size: "mini", status: "online", circular: true },
                        React.createElement(FormattedMessage, { id: "common.text.added", defaultMessage: "ADDED" })))
                : null,
            this.props.thumbnail ? (React.createElement("img", { src: this.props.thumbnail, className: "thumbnail" })) : (React.createElement("div", { className: "icon" },
                React.createElement("div", null,
                    React.createElement(Icon, { name: "app", color: Theme.color.silver })))),
            React.createElement("div", { className: "content" },
                React.createElement("h3", { className: "title" }, this.props.name),
                React.createElement("p", { className: "category" }, this.props.categories.join(', ')))));
    };
    return AppCard;
}(React.Component));
export default AppCard;
//# sourceMappingURL=index.js.map